export const COUNTRY_CALLING_CODES = [
  { code: "1809", country: "República Dominicana" },
  { code: "1829", country: "República Dominicana" },
  { code: "1849", country: "República Dominicana" },
  { code: "1787", country: "Puerto Rico" },
  { code: "1939", country: "Puerto Rico" },
  { code: "593", country: "Ecuador" },
  { code: "591", country: "Bolivia" },
  { code: "598", country: "Uruguay" },
  { code: "595", country: "Paraguay" },
  { code: "506", country: "Costa Rica" },
  { code: "507", country: "Panamá" },
  { code: "502", country: "Guatemala" },
  { code: "503", country: "El Salvador" },
  { code: "504", country: "Honduras" },
  { code: "505", country: "Nicaragua" },
  { code: "509", country: "Haití" },
  { code: "501", country: "Belice" },
  { code: "592", country: "Guyana" },
  { code: "597", country: "Surinam" },
  { code: "594", country: "Guayana Francesa" },
  { code: "54", country: "Argentina" },
  { code: "55", country: "Brasil" },
  { code: "52", country: "México" },
  { code: "57", country: "Colombia" },
  { code: "56", country: "Chile" },
  { code: "51", country: "Perú" },
  { code: "58", country: "Venezuela" },
  { code: "53", country: "Cuba" },
];

export const inferCountryFromPhone = (phone) => {
  if (!phone) return undefined;
  const digits = phone.replace(/\D/g, "");
  if (!digits) return undefined;
  const match = COUNTRY_CALLING_CODES.find(({ code }) => digits.startsWith(code));
  return match?.country;
};

export const getCustomerCountry = (customer) => {
  return customer?.country?.trim() || inferCountryFromPhone(customer?.mainUserPhone);
};
